import type { FlattenedSectionProps } from "../../../components/Questionnaire/Section";
import type { Answer } from "../../../components/Questionnaire/Section/Question/types";
import type { AddressModes } from "../types";

export const setAddressQuestionVisibility = (
  lookupName: string,
  sections: FlattenedSectionProps[],
  addressModes: AddressModes,
  answers?: Record<string, Answer>,
): {
  sections: FlattenedSectionProps[];
  answers: Record<string, Answer>;
} => {
  const updatedAnswers = { ...answers };

  const updatedSections = sections.map((section: FlattenedSectionProps) => {
    const updatedQuestions = section.questions.map(question => {
      const { name, associatedQuestionName } = question;
      // Update relevant address_lookup and text questions
      if (name && addressModes[name] && name === lookupName) {
        return addressModes[name] !== "lookup"
          ? { ...question, visible: false }
          : { ...question, visible: true };
      }
      if (
        associatedQuestionName &&
        addressModes[associatedQuestionName] &&
        associatedQuestionName === lookupName
      ) {
        // Clear existing manual answers when a
        // user clicks "Enter address manually"
        if (addressModes[associatedQuestionName] === "manual") {
          updatedAnswers[name] = "";
          return { ...question, answer: "", visible: true };
        }
        return { ...question, visible: false };
      }
      return question;
    });

    return { ...section, questions: updatedQuestions };
  });

  return {
    sections: updatedSections,
    answers: updatedAnswers,
  };
};

export const setManualQuestionVisibility = (
  sections: FlattenedSectionProps[],
  addressModes: AddressModes,
): FlattenedSectionProps[] => {
  return sections.map((section: FlattenedSectionProps) => {
    const updatedQuestions = section.questions.map(question => {
      const { associatedQuestionName } = question;
      // Only update text questions
      if (associatedQuestionName && addressModes[associatedQuestionName]) {
        return addressModes[associatedQuestionName] === "manual"
          ? { ...question, answer: "", visible: true }
          : { ...question, visible: false };
      }
      return question;
    });

    return { ...section, questions: updatedQuestions };
  });
};

export const setAddressModes = (sections: FlattenedSectionProps[]) => {
  const addressModes = sections.reduce((acc: AddressModes, section) => {
    section.questions.forEach(({ name, display, visible }) => {
      if (display.type === "address_lookup") {
        acc[name] = visible ? "lookup" : "none";
      }
    });
    return acc;
  }, {});
  const updatedSections = setManualQuestionVisibility(sections, addressModes);

  return {
    addressModes,
    sections: updatedSections,
  };
};
